import { useAppDispatch } from "../hooks";
import { dismiss } from "../slices/dialogsSlice";

interface ConfirmDialogProps {
    resultListener: (result: boolean) => void;
    warningText: string;
    dialogId: number;
}

const ConfirmDialog = ({ resultListener, warningText, dialogId }: ConfirmDialogProps) => {
    const dispatch = useAppDispatch();

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    const resolve = (result: boolean) => {
        resultListener(result);
        close();
    };

    return (
        <>
            <h1>Are you sure?</h1>

            <p>{warningText}</p>

            <div className="button-row">
                <button
                    className="warn"
                    onClick={() => {
                        resolve(true);
                    }}
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        resolve(false);
                    }}
                >
                    No
                </button>
            </div>
        </>
    );
};

export default ConfirmDialog;
